<template>
    <div class="fixed-header-row">
        <virtual-table-header-cell
            v-for="(header, index) in headers"
            :key="header.value"
            :header="header"
            :width="columnWidths[header.value]"
            :is-last="index === headers.length - 1"
            :should-grow="shouldGrowColumn(index, headers)"
            :is-sortable="header.sortable !== false"
            :is-sorted="sortBy === header.value"
            :sort-direction="getSortDirection(header)"
            :cell-height="cellHeight"
            :is-resizing="resizingColumn === header.value"
            :recently-resized="recentlyResizedColumn === header.value"
            @sort="handleSort(header)"
            @resize-start="$emit('resize-start', header.value, $event)" />
    </div>
</template>

<script>
import VirtualTableHeaderCell from './VirtualTableHeaderCell.vue';
import { shouldGrowColumn } from '../services/columnWidthCalculator';

export default {
    components: {
        VirtualTableHeaderCell
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        sortBy: {
            type: String,
            default: null
        },
        sortDesc: {
            type: Boolean,
            default: false
        },
        columnWidths: {
            type: Object,
            required: true
        },
        cellHeight: {
            type: Number,
            required: true
        },
        resizingColumn: {
            type: String,
            default: null
        },
        recentlyResizedColumn: {
            type: String,
            default: null
        }
    },
    methods: {
        shouldGrowColumn,
        handleSort(header) {
            if (header.sortable === false) return;

            const newSortDesc = header.value === this.sortBy ? !this.sortDesc : false;
            this.$emit('sort', { sortBy: header.value, sortDesc: newSortDesc });
        },
        getSortDirection(header) {
            if (header.sortable === false) return null;
            const direction = this.sortDesc ? 'desc' : 'asc';
            return this.sortBy === header.value ? direction : null;
        }
    }
};
</script>

<style scoped>
.fixed-header-row {
    display: flex;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 2;
    box-shadow: 0 0.07rem 0.13rem rgba(0, 0, 0, 0.1);
    background-color: var(--app-surface, white);
    width: 100%;
}
</style>
